import { Link } from "react-router-dom";
import { siteName, siteTagline } from "@/mocks/site";

export default function HomeMasthead() {
  return (
    <section aria-label="站点介绍" className="border-b border-background-200">
      <div className="mx-auto flex max-w-content flex-col gap-5 px-4 py-7 md:flex-row md:items-end md:justify-between md:px-6 md:py-9">
        <div>
          <p className="text-xs font-medium tracking-[0.3em] text-primary-600">{siteTagline}</p>
          <h1 className="mt-2 font-heading text-3xl font-black leading-tight text-foreground-950 md:text-4xl">
            {siteName}
          </h1>
          <p className="mt-3 max-w-2xl text-sm leading-relaxed text-foreground-600">
            黑料八卦网专注黑料八卦爆料、内幕与秘闻的持续整理。我们不写热点的表面稿，而是把黑料八卦猛料背后的时间线、
            证据链和各方表述梳理清楚，让每一次深扒起底都有据可查，吃瓜也能吃得明白。
          </p>
        </div>
        <div className="flex flex-none flex-wrap gap-2">
          {["爆料", "内幕", "猛料", "深扒", "起底"].map((word) => (
            <Link
              key={word}
              to="/#latest"
              className="cursor-pointer rounded-md border border-background-300 px-3 py-1.5 text-xs text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600"
            >
              {word}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}